<template>
  <div class="faq-tabs">
    <!-- Sidebar tabs -->
    <div class="flex flex-col md:flex-row">
      <!-- Tab navigation -->
      <div class="w-full md:w-64 border-r border-stone-200 dark:border-stone-700">
        <div class="sticky top-0">
          <ul class="flex flex-col">
            <li v-for="(tab, index) in tabs" :key="tab.name"
              class="border-b border-stone-200 dark:border-stone-700 last:border-b-0">
              <router-link :to="{ name: 'faq-section', params: { section: tab.name } }"
                class="w-full block py-3 px-4 text-left font-medium focus:outline-none transition-colors" :class="activeSection === tab.name
                    ? 'bg-primary-50 dark:bg-primary-900/20 text-primary-600 dark:text-primary-400'
                    : 'text-stone-700 dark:text-stone-300 hover:bg-stone-100 dark:hover:bg-stone-800'
                  ">
                {{ formatTabName(tab.name) }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <!-- Tab content - now using dynamic components -->
      <div class="w-full p-4">
        <component :is="currentFaqComponent"></component>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { faqComponents } from './faq';

const route = useRoute();

const tabs = ref([
  { name: 'welcome', pos: 0 },
  { name: 'ads', pos: 1 },
  { name: 'behavior', pos: 2 },
  { name: 'business', pos: 3 },
  { name: 'credits', pos: 4 },
  { name: 'embedding', pos: 5 },
  { name: 'how-to', pos: 6 },
  { name: 'randomness', pos: 7 },
  { name: 'sound', pos: 8 },
  { name: 'maintainer', pos: 9 },
  { name: 'funding', pos: 10 },
  { name: 'feedback', pos: 11 },
  { name: 'privacy-summary', pos: 12 },
]);

// Derive active section from the URL (single source of truth)
const activeSection = computed(() => {
  const section = route.params.section ? String(route.params.section) : 'welcome';
  return tabs.value.some((t) => t.name === section) ? section : 'welcome';
});

// Determine which component to render for the active section
const currentFaqComponent = computed(() => {
  return faqComponents[activeSection.value] || faqComponents['welcome'];
});

function formatTabName(name) {
  return name
    .replace(/-|_/g, ' ')
    .replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
}
</script>

<style scoped>
.hero-numbers-grid {
  display: grid;
  grid-template-columns: 200px 200px;
  grid-gap: 30px;
}

.faq-tabs {
  @apply w-full;
}
</style>
